import { useCallback, useRef } from 'react';

import { yidunCaptchaId } from '../utils';

declare global {
  interface Window {
    initNECaptchaWithFallback: Function;
  }
}
/**图形验证码 */
export const useInitYidunCaptcha = (
  setYidunCaptcha: React.Dispatch<React.SetStateAction<string>>,
  opt?: { mode: 'float' | 'popup' }
) => {
  const mode = opt?.mode ?? 'float';
  const yidunCaptchaInstance = useRef<{ verify: () => boolean }>();
  const setYidunCaptchaRef = useRef(setYidunCaptcha);
  setYidunCaptchaRef.current = setYidunCaptcha;

  const initNECaptcha = useCallback(() => {
    if (typeof window.initNECaptchaWithFallback !== 'function') {
      console.log('?');
    }
    // window.initNECaptchaWithFallback(
    //   {
    //     element: '#yidun-captcha',
    //     captchaId: yidunCaptchaId,
    //     width: mode === 'float' ? '100%' : `${window.innerWidth * 0.7}px`,
    //     mode,
    //     apiVersion: 2,
    //     feedbackEnable: false,
    //     onVerify(err: any, data: any) {
    //       if (err) return; // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
    //       // 若成功拿到 validate，可向后端发送请求
    //       setYidunCaptchaRef.current(data.validate);
    //     },
    //   },
    //   (instance: any) => {
    //     yidunCaptchaInstance.current = instance;
    //   },
    //   (err: any) => {
    //     // eslint-disable-next-line no-console
    //     console.warn(err);
    //   }
    // );
  }, []);

  return { initNECaptcha, yidunCaptchaInstance };
};
